<script>
import {mapStores} from "pinia";
import {useAuthStore} from "@/stores/auth";
import GeneralStats from "@/components/admin/dashboard/GeneralStats.vue";
import LineUserByMonth from "@/components/admin/dashboard/LineUserByMonth.vue";
import LineOrdersByMonth from "@/components/admin/dashboard/LineOrdersByMonth.vue";
import BarSalesByProduct from "@/components/admin/dashboard/BarSalesByProduct.vue";

export default {
  name: 'HomeAdminView',
  components: {BarSalesByProduct, LineOrdersByMonth, LineUserByMonth, GeneralStats},
  computed: {
    ...mapStores(useAuthStore),
    isMobile () {
      return window.innerWidth <= 768
    }
  },
  data () {
    return {
      options: {
        chart: {
          id: 'vuechart-example'
        },
        xaxis: {
          categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
        }
      },
      series: [{
        name: 'series-1',
        data: [30, 40, 45, 50, 49, 60, 70, 91]
      }]
    }
  }
}
</script>

<template>
  <div>
    <div class="p-4">
      <div class="mb-10">
        <h1 class="mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-900">
          Bonjour <span class="underline underline-offset-3 decoration-8 decoration-primary-700">{{ authStore.getUser.firstname }}</span>
        </h1>
      </div>
      <general-stats />
      <div class="flex flex-wrap lg:grid lg:grid-cols-2 lg:gap-4 mb-4">
        <div class="flex flex-col items-center justify-center rounded bg-gray-50">
          <h1 class="text-gray-400 text-left">Nombre d'utilisateur par mois</h1>
          <line-user-by-month :width="isMobile ? 300 : 550" />
        </div>
        <div class="flex flex-col items-center justify-center rounded bg-gray-50">
          <h1 class="text-gray-400 text-left">Nombre de commande par mois</h1>
          <line-orders-by-month :width="isMobile ? 300 : 550" />
        </div>
<!--        <div class="flex flex-col items-center justify-center rounded bg-gray-50">-->
<!--          <h1 class="text-gray-400 text-left">Nombre de vente par catégorie</h1>-->
<!--            <bar-sales-by-category :width="isMobile ? 250 : 550" /> -->
<!--        </div>-->
        <div class="flex flex-col items-center justify-center rounded bg-gray-50">
          <h1 class="text-gray-400 text-left">Nombre de vente par produit</h1>
          <bar-sales-by-product :width="isMobile ? 350 : 550" />
        </div>
      </div>
      <div class="flex items-center justify-center h-48 mb-4 rounded bg-gray-50 dark:bg-gray-800">
        <p class="text-2xl text-gray-400 dark:text-gray-500">
          <svg class="w-3.5 h-3.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 1v16M1 9h16"/>
          </svg>
        </p>
      </div>
      <div class="grid grid-cols-2 gap-4">
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 dark:bg-gray-800">
          <p class="text-2xl text-gray-400 dark:text-gray-500">
            <svg class="w-3.5 h-3.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 1v16M1 9h16"/>
            </svg>
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 dark:bg-gray-800">
          <p class="text-2xl text-gray-400 dark:text-gray-500">
            <svg class="w-3.5 h-3.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 1v16M1 9h16"/>
            </svg>
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 dark:bg-gray-800">
          <p class="text-2xl text-gray-400 dark:text-gray-500">
            <svg class="w-3.5 h-3.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 1v16M1 9h16"/>
            </svg>
          </p>
        </div>
        <div class="flex items-center justify-center rounded bg-gray-50 h-28 dark:bg-gray-800">
          <p class="text-2xl text-gray-400 dark:text-gray-500">
            <svg class="w-3.5 h-3.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 1v16M1 9h16"/>
            </svg>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>